import {
    GET_MEMBERSHIPTYPES, 
    SELECT_MEMBERSHIPTYPE,
    GET_MEMBERSHIPPACKAGES, 
    SELECT_MEMBERSHIPPACKAGE,
    ADD_MEMBERSHIP,
    ADD_INTEREST_FOR_MEMBERSHIP,
    ADD_ADDONS,
    ADD_DONATIONS,
    SELECT_PAYWITHCARD,
    SIGNUP_USERINFO,
    GET_ADDONS,
    GET_DONATIONS,
    UPDATE_PAYMENT_REQUEST,
    UPDATE_PAYMENT_SUCCESS,
    UPDATE_PAYMENT_ERROR,
    CLEAR_ALERTS,
} from '../../Actions/EndUser/MembershipAction';

import {
    SET_USER_ID
} from '../../Actions/EndUser/AuthActions';

export const reducer = (state = {
    userId: null,
    inviteMember: null,
    membershipTypes: [],
    selectedMembershipType: null,
    membershipPackages: [],
    selectedmembershipPackage: null,
    selectedPaywithCard: true,
    membershipInformation: null,
    interests: null,
    donations: [],
    allDonationOptions: null,
    updateInvitation: null,
    signupUserInfo: null,
    allAddonOptions: null,
    addons: [],
    updatingPayment: false,
    alertMessage: null,
    alertVisible: false,
    alertColor: null,
}, action) => {
    switch (action.type) {
        case GET_MEMBERSHIPTYPES:
            return {
                ...state,
                membershipTypes: action.membershipTypes
            };
        case SELECT_MEMBERSHIPTYPE:
            return {
                ...state,
                selectedMembershipType: action.selectedMembershipType
            };
        case GET_MEMBERSHIPPACKAGES:
            return {
                ...state,
                membershipPackages: action.membershipPackages
            };
        case SELECT_MEMBERSHIPPACKAGE:
            return {
                ...state,
                selectedmembershipPackage: action.selectedmembershipPackage
            };
        case ADD_MEMBERSHIP:
            return {
                ...state,
                membershipInformation: action.inputMembershipInformation
            };
        case ADD_INTEREST_FOR_MEMBERSHIP:
            return {
                ...state,
                interests: action.interests
            };
        case ADD_ADDONS:
            return {
                ...state,
                addons: action.addons
            };
        case ADD_DONATIONS:
            return {
                ...state,
                donations: action.donations
            }; 
        case SIGNUP_USERINFO:
            return {
                ...state,
                signupUserInfo: action.payload
            };
        case SET_USER_ID:
            return {
                ...state,
                userId: action.payload
            }; 
        case GET_ADDONS:
            return {
                ...state,
                allAddonOptions: action.payload
            }; 
        case GET_DONATIONS:
            return {
                ...state,
                allDonationOptions: action.payload
            };
        case UPDATE_PAYMENT_REQUEST:
            return {
                ...state,
                updatingPayment: true
            };
        case UPDATE_PAYMENT_SUCCESS:
            //console.log(state);
            return {
                ...state,
                updatingPayment: false,
                alertMessage: action.payload,
                alertVisible: true,
                alertColor: "success"
            };
        case UPDATE_PAYMENT_ERROR:
            return {
                ...state,
                updatingPayment: false,
                alertMessage: action.payload,
                alertVisible: true,
                alertColor: "danger"
            };
        case CLEAR_ALERTS:
            return {
                ...state,
                alertMessage: '',
                alertVisible: false,
                alertColor: ''
            };
            default:
            return state;
    }
}
